export const initialState = {
  confirmSMSCodeFetch: false,
  inputWarning: null,
  timerStartTime: 0,
  otpId: null,
};
